<!-- src/app/meter/components/meter-analytics/meter-alert-trend/meter-alert-trend.component.html -->

<div class="chart-card">
    <h3 class="chart-title">{{ 'meter.analytics.chart_alert_volume' | translate }}</h3>
    <div class="chart-container">
        <canvas baseChart
            *ngIf="data && data.current.length > 0"
            type="line"
            [data]="chartData"
            [options]="chartOptions">
        </canvas>
        <div *ngIf="!data || data.current.length === 0" class="no-data">
            {{ 'meter.analytics.no_data' | translate }}
        </div>
    </div>
</div>
